import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "fixed inset-0 overflow-y-auto"
};
const _hoisted_2 = {
  class: "flex min-h-full items-center justify-center p-4 sm:p-8 text-center"
};
const _hoisted_3 = {
  class: "max-h-[70vh] overflow-y-auto overflow-x-hidden space-y-4"
};
const _hoisted_4 = {
  class: "font-bold text-slate-800 dark:text-black mb-3"
};
const _hoisted_5 = {
  class: "grow text-slate-700 news-feedback",
  style: {
    "display": "flex",
    "align-items": "baseline"
  }
};
const _hoisted_6 = {
  style: {
    "margin-right": "0.5rem",
    "white-space": "nowrap",
    "line-height": "1.25rem"
  },
  class: /*@__PURE__*/_normalizeClass(`inline-block px-1 py-0.5 text-xs rounded bg-green-100 dark:bg-green-900 text-green-700 dark:text-green-300`)
};
const _hoisted_7 = {
  class: "mt-2 sm:mt-8 flex justify-end space-x-3"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_TransitionChild = _resolveComponent("TransitionChild");
  const _component_DialogTitle = _resolveComponent("DialogTitle");
  const _component_DialogPanel = _resolveComponent("DialogPanel");
  const _component_Dialog = _resolveComponent("Dialog");
  const _component_TransitionRoot = _resolveComponent("TransitionRoot");
  return _openBlock(), _createBlock(_component_TransitionRoot, {
    key: _ctx.$route.hash,
    appear: "",
    show: _ctx.isOpen,
    as: "template",
    class: "z-10"
  }, {
    default: _withCtx(() => [_createVNode(_component_Dialog, {
      as: "div",
      onClose: $options.closeDialog,
      class: "relative",
      open: _ctx.isOpen
    }, {
      default: _withCtx(() => [_createVNode(_component_TransitionChild, {
        as: "template",
        enter: "duration-300 ease-out",
        "enter-from": "opacity-0",
        "enter-to": "opacity-100",
        leave: "duration-200 ease-in",
        "leave-from": "opacity-100",
        "leave-to": "opacity-0"
      }, {
        default: _withCtx(() => _cache[1] || (_cache[1] = [_createElementVNode("div", {
          class: "fixed inset-0 bg-black/25"
        }, null, -1)])),
        _: 1
      }), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_TransitionChild, {
        as: "template",
        enter: "duration-300 ease-out",
        "enter-from": "opacity-0 scale-95",
        "enter-to": "opacity-100 scale-100",
        leave: "duration-200 ease-in",
        "leave-from": "opacity-100 scale-100",
        "leave-to": "opacity-0 scale-95"
      }, {
        default: _withCtx(() => [_createVNode(_component_DialogPanel, {
          style: {
            "background": "#F6F9FB"
          },
          class: "w-full max-w-4xl transform overflow-hidden rounded-lg bg-white dark:bg-white p-3 sm:p-6 text-left align-middle shadow-lg dark:shadow-gray-900 transition-all"
        }, {
          default: _withCtx(() => [_createVNode(_component_DialogTitle, {
            as: "h3",
            class: "text-2xl font-bold leading-6 text-slate-800 dark:text-black mb-3 sm:mb-6"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("HeaderView.HeaderFAQ.faq")), 1)]),
            _: 1
          }), _createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.faq, (item, i) => {
            return _openBlock(), _createElementBlock("div", {
              key: i,
              class: "flex flex-col p-4 mb-4 rounded-lg border border-slate-300 dark:border-gray-700 shadow-md hover:shadow-lg bg-white dark:bg-white"
            }, [_createElementVNode("div", _hoisted_4, _toDisplayString(item.q), 1), _createElementVNode("div", _hoisted_5, [_createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t("HeaderView.HeaderFAQ.answerText")), 1), _createTextVNode(" " + _toDisplayString(item.a), 1)])]);
          }), 128))]), _createElementVNode("div", _hoisted_7, [_createElementVNode("button", {
            class: "btn2 inline-flex justify-center rounded-full px-4 py-2 shadow-lg hover:shadow-lg bg-indigo-500 dark:bg-indigo-600 text-black hover:bg-indigo-600 dark:hover:bg-indigo-500 transition-colors duration-200",
            onClick: _cache[0] || (_cache[0] = (...args) => $options.closeDialog && $options.closeDialog(...args))
          }, _toDisplayString(_ctx.$t("HeaderView.HeaderAbout.close")), 1)])]),
          _: 1
        })]),
        _: 1
      })])])]),
      _: 1
    }, 8, ["onClose", "open"])]),
    _: 1
  }, 8, ["show"]);
}